import React from "react";
import TextBox from "../../../components/atoms/input/textBox";
import {TextObservable} from "../textObservable";
import {RadioGroupKeyValue} from "./radioGroupKeyValue";

// Key value with a text input
export class TextRadioGroupKeyValue extends RadioGroupKeyValue {
  textInput: TextObservable;
  placeholder?: string;

  constructor(
    value: string,
    label: string,
    textInput: TextObservable,
    placeholder?: string,
    tooltip?: string
  ) {
    super(value, label, tooltip);
    this.textInput = textInput;
    this.placeholder = placeholder;
  }

  get hasCustomInput(): boolean {
    return true;
  }

  renderCustomInput(isDisabled: boolean): JSX.Element | null {
    return (
      <TextBox
        type="text"
        value={this.textInput}
        disabled={isDisabled}
        placeholder={this.placeholder}
      />
    );
  }

  get enteredValue(): string {
    if (this.textInput.text) {
      return this.textInput.text;
    }
    return this.value;
  }
}
